const time = new Intl.DateTimeFormat("nl-BE", { hour: "2-digit", minute: "2-digit" });
const date = new Intl.DateTimeFormat("nl-BE", { day: "2-digit", month: "2-digit", year: "numeric" });

const toDate = (value: string | Date) => (typeof value === "string" ? new Date(value) : value);

/** "20:14" */
export function formatTime(value: string | Date): string {
  return time.format(toDate(value));
}

/** "30/09/2026" */
export function formatDate(value: string | Date): string {
  return date.format(toDate(value));
}

/** "17", "17.00", "17h00" or "17:00" → "17:00"; null when it is no time (hours as the owner types them). */
export function readTime(text: string): string | null {
  let value = text.trim().replace(/[.h]/, ":");
  if (/^\d{1,2}$/.test(value)) value += ":00";
  const match = /^(\d{1,2}):(\d{2})$/.exec(value);
  if (!match || Number(match[1]) > 23 || Number(match[2]) > 59) return null;
  return `${match[1]!.padStart(2, "0")}:${match[2]!}`;
}
